<template>
    <div class="DistrictManagement">
      <DistrictManagement/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import DistrictManagement from '@/components/DistrictManagement.vue'
  
  export default {
    name: 'venue-Management-view',
    components: {
      DistrictManagement
    }
  }
  </script>
  